import { install } from "vue3-recaptcha-v2";

export default defineNuxtPlugin((nuxtApp) => {
  const {
    public: { recaptcha },
  } = useRuntimeConfig()

  nuxtApp.vueApp.use(install, {
    sitekey: recaptcha.v2SiteKey,
    cnDomains: false,
  });
});